import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * A hook that adds keyboard shortcuts for navigation 
 * 
 * Keyboard shortcuts:
 * - Alt + H: Go to home page
 * - Alt + A: Go to about page
 * - Alt + B: Go to blogs page
 * - Alt + C: Go to contact page
 * - Alt + E: Go to explore page (if available)
 * - Alt + L: Go to login page
 * - Escape: Close any active modals or popups
 */
export const useKeyboardNavigation = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleKeyDown = (event) => {
      // Only trigger if Alt key is pressed (Meta key for Mac)
      if (event.altKey || event.metaKey) {
        switch(event.key.toLowerCase()) {
          case 'h': 
            event.preventDefault();
            navigate('/');
            break;
          case 'a':
            event.preventDefault();
            navigate('/about');
            break;
          case 'b':
            event.preventDefault();
            navigate('/blogs');
            break;
          case 'c':
            event.preventDefault();
            navigate('/contact');
            break;
          case 'e':
            event.preventDefault();
            navigate('/explore/all'); // Assuming there's an "all" explore page
            break;
          case 'l':
            event.preventDefault();
            navigate('/login');
            break;
          default:
            break;
        }
      }
    };

    // Add event listener
    window.addEventListener('keydown', handleKeyDown);

    // Clean up
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [navigate]);

  // No need to return anything as this is just setting up listeners
};

/**
 * A component to wrap around the application to provide keyboard navigation
 */
export const KeyboardNavigationProvider = ({ children }) => {
  useKeyboardNavigation();
  return children;
}; 